import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { storeReferral, trackReferral } from "@/lib/referral";

/**
 * Iter XX.43 — `/r/:code` direct referral redirect.
 * Sets the first-touch attribution cookie server-side then bounces
 * to the landing page. Never exposes any partner-private info.
 */
export default function ReferralRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;
    async function run() {
      const clean = (code || "").trim().toLowerCase();
      if (!clean) { navigate("/", { replace: true }); return; }
      const res = await trackReferral({ refCode: clean });
      if (res?.ok && res.partner?.username) {
        storeReferral(res.partner.username);
        if (alive) navigate(`/@${res.partner.username}`, { replace: true });
      } else {
        // Unknown code — silently bounce to landing.
        if (alive) navigate("/", { replace: true });
      }
    }
    run();
    return () => { alive = false; };
  }, [code, navigate]);

  return (
    <div className="min-h-screen bg-neutral-950 text-neutral-100 flex items-center justify-center" data-testid="referral-redirect">
      <div className="text-neutral-500">Redirecting…</div>
    </div>
  );
}
